<template>
  <div>
    <v-dialog
      v-if="selected && selected_image"
      v-model="showImageDialog"
      scrollable
      width="auto"
    >
      <v-card>
        <v-card-title>
          <span class="text-h5">Image</span>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-row>
              <v-col cols="12" sm="12" md="12" class="text-center">
                <img style="max-width: 100%;" :src="selected_image" alt="" />
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            @click="downloadImage(selected, 'inactivePhoto')"
          >
            <b-icon icon="download" aria-hidden="true"></b-icon>
            {{ $t("Download") }}
          </v-btn>
          <v-btn color="blue darken-1" text @click="closeImageDialog">
            {{ $t("cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-if="selected" scrollable v-model="showEdit" max-width="600px">
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-card>
          <v-card-title class="title_wrapper">
            <span class="text-h5">{{ `${$t("Inactive")} POS` }}</span>
          </v-card-title>

          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="12">
                  <h6 class="my-2">{{ $t("The brands to Inactivate") }} :</h6>
                  <v-autocomplete
                    v-model="selected.brands"
                    :items="selected.brands"
                    item-text="name"
                    item-value="id"
                    filled
                    multiple
                    required
                    :rules="requiredRules"
                    readonly
                    class="readonly_component"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12">
                  <h6 class="my-2">{{ $t("The reason to Inactivate") }} :</h6>
                  <v-autocomplete
                    v-model="selected.reasonType"
                    :items="reasonTypes"
                    item-text="label"
                    item-value="value"
                    filled
                    required
                    :rules="requiredRules"
                    readonly
                    class="readonly_component"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12">
                  <h6 class="my-2">{{ $t("Explain the reason") }} :</h6>
                  <v-textarea
                    v-model="selected.gpvComments"
                    class="gpv_comment_text readonly"
                    readonly
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12">
                  <h6 class="my-2">
                    {{ $t("Responsible OK / NOT OK") }}
                    <span v-if="isResponsableEditable" class="required ml-2"
                      >*</span
                    >
                    :
                  </h6>
                  <v-autocomplete
                    v-model="selected.responsableApprovalStatus"
                    :items="responsableApprovalStatusValues"
                    item-text="label"
                    item-value="value"
                    filled
                    required
                    :rules="isResponsableEditable ? requiredRules : []"
                    :readonly="!isResponsableEditable"
                    v-bind:class="
                      !isResponsableEditable ? 'readonly_component' : ''
                    "
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12">
                  <h6 class="my-2">
                    {{
                      `${this.$t("salesforce.Parent")} ${this.$t("comments")}`
                    }}
                    <span v-if="isResponsableEditable" class="required ml-2"
                      >*</span
                    >
                    :
                  </h6>
                  <v-textarea
                    v-model="selected.responsableComments"
                    :readonly="!isResponsableEditable"
                    v-bind:class="
                      `gpv_comment_text ${
                        !isResponsableEditable ? 'readonly' : ''
                      }`
                    "
                    required
                    :rules="isResponsableEditable ? requiredRules : []"
                  ></v-textarea>
                </v-col>
              </v-row>
              <v-row v-if="isShowAdminInputs">
                <v-col cols="12" md="12">
                  <h6 class="my-2">
                    {{ `${this.$t("Final")} ${this.$t("Decision")}` }}
                    <span v-if="isAdminEditable" class="required ml-2">*</span>
                    :
                  </h6>
                  <v-autocomplete
                    v-model="selected.adminApprovalStatus"
                    :items="adminApprovalStatusValues"
                    item-text="label"
                    item-value="value"
                    filled
                    required
                    :rules="isAdminEditable ? requiredRules : []"
                    :readonly="!isAdminEditable"
                    v-bind:class="!isAdminEditable ? 'readonly_component' : ''"
                  ></v-autocomplete>
                </v-col>
              </v-row>
              <v-row v-if="isShowAdminInputs">
                <v-col cols="12" md="12">
                  <h6 class="my-2">
                    {{ `${this.$t("Final")} ${this.$t("comments")}` }}
                    <span v-if="isAdminEditable" class="required ml-2">*</span>
                    :
                  </h6>
                  <v-textarea
                    v-model="selected.adminComments"
                    :readonly="!isAdminEditable"
                    v-bind:class="
                      `gpv_comment_text ${!isAdminEditable ? 'readonly' : ''}`
                    "
                    required
                    :rules="isAdminEditable ? requiredRules : []"
                  ></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" text @click="closeEditDialog">
              {{ $t("cancel") }}
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              :loading="isSaving"
              @click="onSaveClick(selected)"
              ref="btnSave"
              v-if="isShowSaveBtn"
            >
              {{ $t("save") }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <v-card elevation="2" outlined shaped tile class="mb-2">
      <v-card-title>{{ `POS ${$t("Inactive")}` }}</v-card-title>
      <v-card-text>
        <div class="status_wrapper d-flex justify-content-center align-center">
          <b-card
            bg-variant="dark"
            v-bind:header="$t('Pending Responsible')"
            class="text-center mr-2"
            style="width:200px"
          >
            <b-card-text>{{ pendingCountResponsable }}</b-card-text>
          </b-card>
          <b-card
            bg-variant="dark"
            v-bind:header="$t('Pending Admin')"
            class="text-center ml-2"
            style="width:200px"
          >
            <b-card-text>{{ pendingCountAdmin }}</b-card-text>
          </b-card>
        </div>
        <v-row
          class="status_wrapper d-flex justify-content-center align-center"
        >
          <v-col cols="12" sm="12" md="12">
            <v-btn color="warning" dark class="ml-2" @click="downloadExcel">
              <b-icon icon="file-excel-fill" aria-hidden="true"></b-icon>
              Export
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <ve-table
              ref="tableRefroutes"
              id="posinactive_table"
              fixed-header
              max-height="calc(100vh - 330px)"
              :columns="columns"
              :table-data="data"
              :border-around="true"
              :border-x="true"
              :border-y="true"
              :scroll-width="1500"
              :sort-option="sortOption"
              :cell-style-option="cellStyleOption"
            />
            <div v-show="showEmpty" class="empty-data">Data Empty.</div>
            <div class="table-pagination mt-2 text-right">
              <ve-pagination
                :total="totaldata"
                :page-index="pageIndex"
                :page-size="pageSize"
                :page-size-option="pageOptions"
                @on-page-number-change="pageNumberChange"
                @on-page-size-change="pageSizeChange"
              />
            </div>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ApiService from "@/services/apiService";
import { logInfo, logError } from "@/utils";
import download from "js-file-download";
import _ from "lodash";

export default {
  name: "inactivepos",
  data: function() {
    return {
      filterlist_fetch_url: "pos/inactive/getfilterlist",
      filterable_col_list: [
        "date",
        "routeId",
        "userId",
        "pos_detail",
        "brands",
        "reasonType",
        "gpvComments",
        "responsableComments",
        "adminComments",
        "responsableApprovalStatus",
        "adminApprovalStatus"
      ],
      filterCriteria: {
        date: {},
        routeId: {},
        userId: {},
        pos_detail: {},
        brands: {},
        reasonType: {},
        gpvComments: {},
        responsableComments: {},
        adminComments: {},
        responsableApprovalStatus: {},
        adminApprovalStatus: {}
      },
      cellStyleOption: {
        headerCellClass: ({ column, rowIndex }) => {
          if (this.filterable_col_list.includes(column.field)) {
            return "filterable-column " + column.field;
          }
        }
      },
      loadingInstance: null,
      sorting: null,
      sortOption: {
        sortChange: params => {
          this.sortChange(params);
        }
      },
      pageIndex: 1,
      pageSize: 100,
      pageOptions: [10, 50, 100],
      showEmpty: false,

      totaldata: 0,
      data: [],
      reasonTypes: [],
      responsableApprovalStatusValues: [],
      adminApprovalStatusValues: [],
      pendingCountResponsable: 0,
      pendingCountAdmin: 0,

      /********** image dialog options **********/
      showImageDialog: false,
      selected_image: null,

      /********** create or edit dialog options **********/
      showEdit: false,
      selected: null,
      editedIndex: -1,
      valid: true,
      requiredRules: [v => !!v || "Required"],
      isSaving: false
    };
  },
  watch: {},
  computed: {
    ...mapGetters("auth", [
      "isAuthenticated",
      "isSPV",
      "isManager",
      "isSubAdmin",
      "isAdmin",
      "user"
    ]),
    isResonsableRole() {
      return this.isSPV || this.isManager || this.isSubAdmin;
    },
    isAdminRole() {
      return this.isAdmin;
    },
    isResponsableEditable() {
      if (
        this.selected &&
        this.isResonsableRole &&
        this.selected.adminApprovalStatus !== "APPROVED"
      ) {
        return true;
      }
      return false;
    },
    isAdminEditable() {
      if (this.isAdminRole) {
        return true;
      }
      return false;
    },
    isShowAdminInputs() {
      if (this.selected) {
        if (this.isAdminRole) {
          return true;
        } else if (
          this.isResonsableRole &&
          this.selected.adminApprovalStatus !== "PENDING"
        ) {
          return true;
        }
      }
      return false;
    },
    isShowSaveBtn() {
      if (
        this.isResonsableRole &&
        this.selected.adminApprovalStatus === "APPROVED"
      ) {
        return false;
      }
      return true;
    },

    col_id() {
      return {
        key: "id",
        title: "ID",
        field: "id",
        align: "left",
        width: 100,
        sortBy: "desc"
      };
    },
    col_date() {
      return {
        key: "date",
        title: this.$t("Date"),
        field: "date",
        align: "left",
        width: 150,
        sortBy: "",
        filterCustom: {
          defaultVisible: false,
          render: ({ showFn, closeFn }, h) => {
            return (
              <div class="custom-filter">
                <input
                  type="date"
                  class="filter_date_picker"
                  v-model={this.filterCriteria["date"]["from"]}
                  value={this.filterCriteria["date"]["from"]}
                  placeholder="From - "
                />
                <br />
                <input
                  type="date"
                  class="filter_date_picker"
                  v-model={this.filterCriteria["date"]["to"]}
                  value={this.filterCriteria["date"]["to"]}
                  placeholder="To - "
                />
                <div class="custom-filter-operation">
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchCancel(closeFn, "date")}
                  >
                    {this.$t("cancel")}
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchConfirm(closeFn)}
                  >
                    {this.$t("Search")}
                  </v-btn>
                </div>
              </div>
            );
          }
        }
      };
    },
    col_route() {
      return {
        key: "routeId",
        title: this.$t("route"),
        field: "routeId",
        align: "left",
        width: 150,
        sortBy: "",
        renderBodyCell: ({ row, column, rowIndex }, h) => {
          return <span>{row.route && row.route.name}</span>;
        },
        filterCustom: {
          defaultVisible: false,
          render: ({ showFn, closeFn }, h) => {
            return (
              <div class="custom-filter">
                <filterableAjaxCheckboxes
                  v-model={this.filterCriteria["routeId"]}
                  apiUrl={`${this.filterlist_fetch_url}`}
                  columnName={`routeId`}
                  isFullText={true}
                  filterCriteria={this.filterCriteria["routeId"]}
                />
                <div class="custom-filter-operation">
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchCancel(closeFn, "routeId")}
                  >
                    {this.$t("cancel")}
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchConfirm(closeFn)}
                  >
                    {this.$t("Search")}
                  </v-btn>
                </div>
              </div>
            );
          }
        }
      };
    },
    col_user() {
      return {
        key: "userId",
        title: "GPV",
        field: "userId",
        align: "left",
        width: 150,
        sortBy: "",
        renderBodyCell: ({ row, column, rowIndex }, h) => {
          return (
            <span>{row.user && row.user.name + " " + row.user.surname}</span>
          );
        },
        filterCustom: {
          defaultVisible: false,
          render: ({ showFn, closeFn }, h) => {
            return (
              <div class="custom-filter">
                <filterableAjaxCheckboxes
                  v-model={this.filterCriteria["userId"]}
                  apiUrl={`${this.filterlist_fetch_url}`}
                  columnName={`userId`}
                  isFullText={true}
                  filterCriteria={this.filterCriteria["userId"]}
                />
                <div class="custom-filter-operation">
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchCancel(closeFn, "userId")}
                  >
                    {this.$t("cancel")}
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchConfirm(closeFn)}
                  >
                    {this.$t("Search")}
                  </v-btn>
                </div>
              </div>
            );
          }
        }
      };
    },
    col_posId() {
      return {
        key: "posId",
        title: "Id POS",
        field: "posId",
        align: "left",
        width: 100,
        sortBy: ""
      };
    },
    col_pos_detail() {
      return {
        key: "pos_detail",
        title: `POS ${this.$t("detail")}`,
        field: "pos_detail",
        align: "left",
        width: 150,
        sortBy: "",
        renderBodyCell: ({ row, column, rowIndex }, h) => {
          return <span>{row.pos_detail}</span>;
        },
        filterCustom: {
          defaultVisible: false,
          render: ({ showFn, closeFn }, h) => {
            return (
              <div class="custom-filter">
                <filterableAjaxCheckboxes
                  v-model={this.filterCriteria["pos_detail"]}
                  apiUrl={`${this.filterlist_fetch_url}`}
                  columnName={`pos_detail`}
                  isFullText={true}
                  filterCriteria={this.filterCriteria["pos_detail"]}
                />
                <div class="custom-filter-operation">
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchCancel(closeFn, "pos_detail")}
                  >
                    {this.$t("cancel")}
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchConfirm(closeFn)}
                  >
                    {this.$t("Search")}
                  </v-btn>
                </div>
              </div>
            );
          }
        }
      };
    },
    col_brands() {
      return {
        key: "brands",
        title: `${this.$t("brands.brands")}`,
        field: "brands",
        align: "left",
        width: 150,
        renderBodyCell: ({ row, column, rowIndex }, h) => {
          return <span>{row.brandsLabel}</span>;
        },
        filterCustom: {
          defaultVisible: false,
          render: ({ showFn, closeFn }, h) => {
            return (
              <div class="custom-filter">
                <filterableAjaxCheckboxes
                  v-model={this.filterCriteria["brands"]}
                  apiUrl={`${this.filterlist_fetch_url}`}
                  columnName={`brands`}
                  isFullText={true}
                  filterCriteria={this.filterCriteria["brands"]}
                />
                <div class="custom-filter-operation">
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchCancel(closeFn, "brands")}
                  >
                    {this.$t("cancel")}
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchConfirm(closeFn)}
                  >
                    {this.$t("Search")}
                  </v-btn>
                </div>
              </div>
            );
          }
        }
      };
    },
    col_reasonType() {
      return {
        key: "reasonType",
        title: `GPV ${this.$t("reason_type")}`,
        field: "reasonType",
        align: "left",
        width: 180,
        sortBy: "",
        renderBodyCell: ({ row, column, rowIndex }, h) => {
          return <span>{row.reasonTypeLabel}</span>;
        },
        filterCustom: {
          defaultVisible: false,
          render: ({ showFn, closeFn }, h) => {
            return (
              <div class="custom-filter">
                <filterableCheckboxesOthers
                  v-model={this.filterCriteria["reasonType"]}
                  dataList={this.reasonTypes}
                  filterCriteria={this.filterCriteria["reasonType"]}
                  itemvalue="value"
                  itemlabel="label"
                />
                <div class="custom-filter-operation">
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchCancel(closeFn, "reasonType")}
                  >
                    {this.$t("cancel")}
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchConfirm(closeFn)}
                  >
                    {this.$t("Search")}
                  </v-btn>
                </div>
              </div>
            );
          }
        }
      };
    },
    col_gpvComments() {
      return {
        key: "gpvComments",
        title: `GPV ${this.$t("comments")}`,
        field: "gpvComments",
        align: "left",
        width: 250,
        sortBy: "",
        filterCustom: {
          defaultVisible: false,
          render: ({ showFn, closeFn }, h) => {
            return (
              <div class="custom-filter">
                <filterableAjaxCheckboxes
                  v-model={this.filterCriteria["gpvComments"]}
                  apiUrl={`${this.filterlist_fetch_url}`}
                  columnName={`gpvComments`}
                  isFullText={false}
                  filterCriteria={this.filterCriteria["gpvComments"]}
                />
                <div class="custom-filter-operation">
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchCancel(closeFn, "gpvComments")}
                  >
                    {this.$t("cancel")}
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchConfirm(closeFn)}
                  >
                    {this.$t("Search")}
                  </v-btn>
                </div>
              </div>
            );
          }
        }
      };
    },
    col_photo() {
      return {
        key: "photo",
        title: this.$t("Photo"),
        field: "photo",
        align: "left",
        width: 150,
        renderBodyCell: ({ row, column, rowIndex }, h) => {
          if (row.inactivePhoto !== null) {
            let thumbnail_url = this.getImageUri(row.inactivePhoto);
            return (
              <img
                style="border: 1px solid #aaa; cursor: pointer; max-width: 100%;"
                src={thumbnail_url}
                alt=""
                on-click={() =>
                  this.onItemShowImageDialog(row, row.inactivePhoto)
                }
              />
            );
          } else {
            return <span>&nbsp;</span>;
          }
        }
      };
    },
    col_responsableApprovalStatus() {
      return {
        key: "responsableApprovalStatus",
        title: `${this.$t("salesforce.Parent")} OK`,
        field: "responsableApprovalStatus",
        align: "left",
        width: 180,
        sortBy: "",
        renderBodyCell: ({ row, column, rowIndex }, h) => {
          return <span>{row.responsableApprovalStatusLabel}</span>;
        },
        filterCustom: {
          defaultVisible: false,
          render: ({ showFn, closeFn }, h) => {
            return (
              <div class="custom-filter">
                <filterableCheckboxesOthers
                  v-model={this.filterCriteria["responsableApprovalStatus"]}
                  dataList={this.responsableApprovalStatusValues}
                  filterCriteria={
                    this.filterCriteria["responsableApprovalStatus"]
                  }
                  itemvalue="value"
                  itemlabel="label"
                />
                <div class="custom-filter-operation">
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() =>
                      this.searchCancel(closeFn, "responsableApprovalStatus")
                    }
                  >
                    {this.$t("cancel")}
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchConfirm(closeFn)}
                  >
                    {this.$t("Search")}
                  </v-btn>
                </div>
              </div>
            );
          }
        }
      };
    },
    col_responsableComments() {
      return {
        key: "responsableComments",
        title: `${this.$t("salesforce.Parent")} ${this.$t("comments")}`,
        field: "responsableComments",
        align: "left",
        width: 250,
        sortBy: "",
        filterCustom: {
          defaultVisible: false,
          render: ({ showFn, closeFn }, h) => {
            return (
              <div class="custom-filter">
                <filterableAjaxCheckboxes
                  v-model={this.filterCriteria["responsableComments"]}
                  apiUrl={`${this.filterlist_fetch_url}`}
                  columnName={`responsableComments`}
                  isFullText={false}
                  filterCriteria={this.filterCriteria["responsableComments"]}
                />
                <div class="custom-filter-operation">
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() =>
                      this.searchCancel(closeFn, "responsableComments")
                    }
                  >
                    {this.$t("cancel")}
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchConfirm(closeFn)}
                  >
                    {this.$t("Search")}
                  </v-btn>
                </div>
              </div>
            );
          }
        }
      };
    },
    col_adminApprovalStatus() {
      return {
        key: "adminApprovalStatus",
        title: `${this.$t("Final")} ${this.$t("Decision")}`,
        field: "adminApprovalStatus",
        align: "left",
        width: 180,
        sortBy: "",
        renderBodyCell: ({ row, column, rowIndex }, h) => {
          return <span>{row.adminApprovalStatusLabel}</span>;
        },
        filterCustom: {
          defaultVisible: false,
          render: ({ showFn, closeFn }, h) => {
            return (
              <div class="custom-filter">
                <filterableCheckboxesOthers
                  v-model={this.filterCriteria["adminApprovalStatus"]}
                  dataList={this.adminApprovalStatusValues}
                  filterCriteria={this.filterCriteria["adminApprovalStatus"]}
                  itemvalue="value"
                  itemlabel="label"
                />
                <div class="custom-filter-operation">
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() =>
                      this.searchCancel(closeFn, "adminApprovalStatus")
                    }
                  >
                    {this.$t("cancel")}
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchConfirm(closeFn)}
                  >
                    {this.$t("Search")}
                  </v-btn>
                </div>
              </div>
            );
          }
        }
      };
    },
    col_adminComments() {
      return {
        key: "adminComments",
        title: `${this.$t("Final")} ${this.$t("comments")}`,
        field: "adminComments",
        align: "left",
        width: 250,
        sortBy: "",
        filterCustom: {
          defaultVisible: false,
          render: ({ showFn, closeFn }, h) => {
            return (
              <div class="custom-filter">
                <filterableAjaxCheckboxes
                  v-model={this.filterCriteria["adminComments"]}
                  apiUrl={`${this.filterlist_fetch_url}`}
                  columnName={`adminComments`}
                  isFullText={false}
                  filterCriteria={this.filterCriteria["adminComments"]}
                />
                <div class="custom-filter-operation">
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchCancel(closeFn, "adminComments")}
                  >
                    {this.$t("cancel")}
                  </v-btn>
                  <v-btn
                    color="blue darken-1"
                    text
                    on-click={() => this.searchConfirm(closeFn)}
                  >
                    {this.$t("Search")}
                  </v-btn>
                </div>
              </div>
            );
          }
        }
      };
    },
    columns() {
      return [
        this.col_id,
        this.col_date,
        this.col_route,
        this.col_user,
        this.col_posId,
        this.col_pos_detail,
        this.col_brands,
        this.col_reasonType,
        this.col_gpvComments,
        this.col_photo,
        this.col_responsableApprovalStatus,
        this.col_responsableComments,
        this.col_adminApprovalStatus,
        this.col_adminComments,
        {
          key: "actions",
          title: this.$t("edititem"),
          field: "actions",
          align: "center",
          width: 100,
          fixed: "right",
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return (
              <div>
                <v-btn
                  color="blue darken-1"
                  text
                  on-click={() => this.onItemEdit(row)}
                >
                  <b-icon icon="box-arrow-up-right" aria-hidden="true"></b-icon>
                </v-btn>
              </div>
            );
          }
        }
      ];
    }
  },
  methods: {
    getImageUri(imgStatic) {
      if (imgStatic && imgStatic?.type === "file") {
        return ApiService.getFileUri(imgStatic);
      }
      return ApiService.getImageUri(imgStatic);
    },
    onItemShowImageDialog(item, image) {
      this.selected = this.createSelectedModel(item);
      this.editedIndex = this.selected.id;
      this.selected_image = this.getImageUri(image ? image : null);
      this.showImageDialog = true;
    },
    closeImageDialog() {
      this.showImageDialog = false;
      this.$nextTick(() => {
        this.selected = null;
        this.editedIndex = -1;
      });
    },
    async downloadImage(selected, downloadFile) {
      try {
        const response = await ApiService.get(this.selected_image, {
          responseType: "arraybuffer"
        });
        download(response, "download.png");
      } catch (error) {
        // this.close();
      }
    },
    pageNumberChange(pageIndex) {
      this.pageIndex = pageIndex;
      this.getDataFromApi();
    },
    pageSizeChange(pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
      this.getDataFromApi();
    },
    sortChange(params) {
      this.sorting = params;
      this.getDataFromApi();
    },
    searchConfirm(closeFn) {
      closeFn();
      this.pageIndex = 1;
      this.getDataFromApi();
    },
    searchCancel(closeFn, cancelFilterKey) {
      closeFn();
      if (cancelFilterKey === "idposbrand") {
        this.filterCriteria[cancelFilterKey] = null;
      } else {
        this.filterCriteria[cancelFilterKey] = {};
      }
      this.getDataFromApi();
    },
    show() {
      this.loadingInstance = this.$veLoading({
        target: document.querySelector("#posinactive_table"),
        name: "flow" // gird, flow, wave, bounce,
      });
      this.loadingInstance.show();
    },
    close() {
      this.loadingInstance.close();
    },
    getQueryParams() {
      let query_params_string = "";
      let query_params = [];
      query_params.push("page=" + this.pageIndex);
      query_params.push("itemsPerPage=" + this.pageSize);
      if (this.sorting !== null) {
        for (const [key, value] of Object.entries(this.sorting)) {
          if (value !== null && value !== "") {
            query_params.push("sortby=" + key);
            query_params.push(
              "sortdesc=" + (value === "desc" ? "true" : "false")
            );
          }
        }
      }

      let filterModel = [];
      for (const [key, value] of Object.entries(this.filterCriteria)) {
        if (value !== "" && value !== null) {
          if (Object.keys(value).length > 0) {
            filterModel.push({
              columnField: key,
              filterValue: value
            });
          }
        }
      }
      console.log(filterModel);
      let filter_columns = document.querySelectorAll(
        "#posinactive_table .filterable-column"
      );
      for (let i = 0; i < filter_columns.length; i++) {
        filter_columns[i].classList.remove("filter_active");
      }
      if (filterModel.length > 0) {
        filterModel.map(filter_item => {
          for (let i = 0; i < filter_columns.length; i++) {
            if (filter_columns[i].classList.contains(filter_item.columnField)) {
              filter_columns[i].classList.add("filter_active");
            }
          }
          return filter_item;
        });
      }

      query_params_string += query_params.join("&");
      if (filterModel.length > 0) {
        query_params_string +=
          "&filterModel=" + encodeURIComponent(JSON.stringify(filterModel));
      }
      return query_params_string;
    },
    async getDataFromApi() {
      this.show();
      let query_params_string = this.getQueryParams();
      let fetch_url = "pos/inactive";
      if (query_params_string !== "") {
        fetch_url += "?" + query_params_string;
      }
      try {
        const resp = await ApiService.get(fetch_url);
        this.data = resp.data;
        if (this.data.length > 0) {
          this.showEmpty = false;
        } else {
          this.showEmpty = true;
        }
        this.totaldata = resp.total;
        this.reasonTypes = resp.reasonTypeValues;
        this.responsableApprovalStatusValues =
          resp.responsableApprovalStatusValues;
        this.adminApprovalStatusValues = resp.adminApprovalStatusValues;
        this.pendingCountResponsable = resp.pendingCountResponsable;
        this.pendingCountAdmin = resp.pendingCountAdmin;
        this.$store.dispatch("auth/getGlobalState");
        this.close();
      } catch (error) {
        this.close();
      }
    },
    async downloadExcel() {
      this.show();
      let query_params_string = this.getQueryParams();
      let fetch_url = "pos/inactive/downloadexcel";
      if (query_params_string !== "") {
        fetch_url += "?" + query_params_string;
      }
      const response = await ApiService.get(fetch_url, {
        responseType: "blob"
      });
      download(response, "posinactive.xlsx");
      this.close();
    },
    onItemEdit(item) {
      this.selected = this.createSelectedModel(item);
      this.editedIndex = this.selected.id;
      this.showEdit = true;
    },
    closeEditDialog() {
      this.showEdit = false;
      this.$nextTick(() => {
        this.selected = null;
        this.editedIndex = -1;
      });
    },
    createSelectedModel(item) {
      console.log("createSelectedModel - ", item);
      let model = {
        id: _.get(item, "id"),
        brands: _.get(item, "brands"),
        reasonType: _.get(item, "reasonType"),
        gpvComments: _.get(item, "gpvComments"),
        responsableApprovalStatus: _.get(item, "responsableApprovalStatus"),
        responsableComments: _.get(item, "responsableComments"),
        adminApprovalStatus: _.get(item, "adminApprovalStatus"),
        adminComments: _.get(item, "adminComments")
      };
      return model;
    },
    async onSaveClick(item) {
      if (this.$refs.form.validate()) {
        this.isSaving = true;
        let body = _.omit(item, ["brands", "gpvComments", "reasonType"]);
        if (this.isResonsableRole) {
          body = _.omit(body, ["adminComments", "adminApprovalStatus"]);
        } else {
          body = _.omit(body, [
            "responsableComments",
            "responsableApprovalStatus"
          ]);
        }
        if (body.id) {
          try {
            await ApiService.put(`pos/inactive/${body.id}`, body);
            logInfo("Éxito !");
            this.showEdit = false;
            this.$store.dispatch("auth/getGlobalState");
            this.getDataFromApi();
            this.isSaving = false;
          } catch (error) {
            this.isSaving = false;
          }
        }
      }
    },
    init() {
      this.getDataFromApi();
    }
  },
  async mounted() {
    this.init();
  }
};
</script>

<style>
span.required {
  color: #f00;
  font-weight: bold;
}
.theme--light.v-text-field--filled.v-input--is-readonly.readonly_component
  > .v-input__control
  > .v-input__slot {
  background: #c3c3c3;
}
.status_wrapper {
  margin-top: 0;
  color: #000;
}
.status_wrapper .bg-dark {
  background-color: #9f9f9f !important;
}
</style>
